module.exports = __webpack_public_path__ + "static/media/healthylogs.ffcf1c3e.jpg";